var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{attrs:{"autocomplete":"","disabled":_vm.readonly},on:{"change":_vm.handleChange},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}},_vm._l((_vm.list),function(data,index){return _c('vs-select-item',{key:index,attrs:{"text":_vm.$t(data.text),"value":data.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }